import React, { useMemo } from "react";
import { Tag, Popconfirm, Button, Space, Typography } from "antd";
import type { ColumnsType } from "antd/es/table";
import type { Role } from "../../../types/roleTypes";
import { useTranslation } from "react-i18next";
import Datatable from "components/Common/dataTable";
import ActionsDropdown, { Action } from "components/Common/ActionsDropdown";
import { showConfirmDialog } from "utils/confirmDialogUtils";
import CustomButton from "components/Common/ui/CustomButton";
import useRoles from "../hooks/useRoles";


type Props = {
  dataSource: Role[];
  loading?: boolean;
  onDelete: (roleId: string) => Promise<boolean> | void | any;
  onEdit: (role: Role) => void;
  dataPaginate: any;
  onChange: (pg: any) => void;
};

const RolesTable: React.FC<Props> = ({ dataSource, loading, onDelete, onEdit , dataPaginate, onChange }) => {
  const { t } = useTranslation();

  const handleDelete = async (record: any) => {
    if (!onDelete) {
      console.warn('onDelete function is not provided');
      return;
    }

    showConfirmDialog({
      title: t("roles.delete_role"),
      content: t("roles.are_you_sure_you_want_to_delete_this_role"),
      okText: t("yes"),
      cancelText: t("no"),
      okType: "danger",
      loading: false,
      onOk: () => onDelete(record.id),
    });
  };
  const columns: ColumnsType<Role> = useMemo(
    () => [
      { title: t("roles.table.name"), dataIndex: "name", key: "name" },
      { title: t("roles.table.slug"), dataIndex: "slug", key: "slug" },
      {
        title: t("roles.table.scope"),
        key: "scope",
        render: (_v, r) => (r.instanceId ? <Tag>{t("roles.instance_role")}</Tag> : <Tag color="blue">{t("roles.system_role")}</Tag>),
      },
      {
        title: t("actions"),
        key: "actions",
        render: (_: string, record: any) => {
          if (record.isSystem) {
            return <CustomButton size="sm" disabled> <i className="ti ti-lock p-2"></i>{t("not_allowed")}</CustomButton>
          }
          const actions: Action[] = [
            {
              label: t("edit"),
              icon: "ti ti-edit",
              actionType: "link",
              onClick: () => onEdit(record),
            },
            {
              label: t("delete"),
              icon: "ti ti-trash",
              actionType: "link",
              onClick: () => handleDelete(record),
            }
          ];
          return <ActionsDropdown actions={actions} />;
        },
      },

    ],
    [t, onDelete]
  );


  return (
    <Datatable
      rowKey="id"
      columns={columns}
      dataSource={dataSource}
      loading={loading}
      pagination={true}
      dataPaginate={dataPaginate}
      onChange={onChange}
    />
  );
};

export default RolesTable;
